module.exports = __webpack_public_path__ + "img/tema-4-1.09ba26cb.png";